import {use} from 'react'

import {ContentfulPricingOptions} from '@github-ui/swp-core/components/contentful/ContentfulPricingOptions'
import {ContentfulPricingOptionsV2} from '@github-ui/swp-core/components/contentful/ContentfulPricingOptionsV2'
import type {PrimerComponentPricingOptions} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentPricingOptions'

import type {GenericGroup} from '../../../../../brand/lib/types/contentful'

import {PlanTypeContext} from '../../_context/PlanTypeContext'
import {PricingRendererContext} from '../../_context/PricingRendererContext'
import {PLAN_TYPES} from '../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'

import styles from './PricingPlans.module.css'

export type {PricingRenderer} from '../../_context/PricingRendererContext'

type Props = {
  contentfulContent: GenericGroup
  variant?: 'default' | 'gridline'
}

export function PricingPlans(props: Props) {
  const {contentfulContent, variant} = props
  const pricingRenderer = use(PricingRendererContext)

  const individualPricingOptions =
    contentfulContent.fields.content.length > 0
      ? (contentfulContent.fields.content.at(0) as PrimerComponentPricingOptions)
      : null

  const businessPricingOptions =
    contentfulContent.fields.content.length > 1
      ? (contentfulContent.fields.content.at(1) as PrimerComponentPricingOptions)
      : null

  const {planType} = use(PlanTypeContext)

  return (
    <div className={`mt-0 tmp-mb-8 ${variant === 'gridline' ? styles['PricingPlans--gridline'] : ''}`}>
      {planType === PLAN_TYPES.Individual && individualPricingOptions ? (
        <div
          id="individual-plan-tab-panel"
          role="tabpanel"
          aria-labelledby="individual-plan-tab"
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          className="lp-PricingPlans-plan"
        >
          {pricingRenderer === 'v2' ? (
            <ContentfulPricingOptionsV2 component={individualPricingOptions} />
          ) : (
            <ContentfulPricingOptions component={individualPricingOptions} />
          )}
        </div>
      ) : null}

      {planType === PLAN_TYPES.Business && businessPricingOptions ? (
        <div
          id="business-plan-tab-panel"
          role="tabpanel"
          aria-labelledby="business-plan-tab"
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          className="lp-PricingPlans-plan"
        >
          <ContentfulPricingOptions component={businessPricingOptions} />
        </div>
      ) : null}
    </div>
  )
}
